import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  ListGroup,
  FormCheck,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import CustomNavbar from "../../components/CustomNavbar";
//import SidebarDashboard from '../../components/SidebarDashboard';
import CustomTable from "../../components/CustomTable";
import {
  getAreas,
  saveAreas,
  editAreas,
  deleteAreas,
} from "../../redux/areasfuncional/actions";
import {
  getUnidadNodes,
  saveUnidadNode,
  deleteUnidadNode,
} from "../../redux/Aurora/unidaNode/actions";
import { getOrgs } from "../../redux/organization/actions";
import messages from "../../redux/messages";
import SidebarConfig from "../../components/SidebarConfig";
import CustomPagint from "../../components/CustomPagint";
import * as Yup from "yup";
import { Formik } from "formik";

const CustomCheckControl = (props) => {
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  //const {saveLoader} = useSelector(store => store.unidadNodes);
  const handleAddUnidadNode = (e, childId) => {
    // const filterChildren = props.unidadNodes.filter(item => item.state === true);
    // let childrenNodes = [];

    // if(filterChildren){
    //   filterChildren.map(item => {
    //     childrenNodes = [...childrenNodes, item.id];
    //   });
    // }

    const data = { unidad: props.nodeid, hijos: [childId] };
    // debugger;
    if (e.target.checked) {
      // childrenNodes.push(childId);
      // data.hijos = childrenNodes;
      dispatch(saveUnidadNode(data, setLoader));
    } else {
      //childrenNodes.splice(childId, 1);
      //data.hijos = childrenNodes;
      dispatch(deleteUnidadNode(data, setLoader));
    }
  };

  return (
    <>
      <div>
        <h6>Código: {props.item.codigo}</h6>
        <h6>Nombre: {props.item.nombre}</h6>
        <p>Dirigido por: {props.item.Dirigido_por}</p>
        {loader && (
          <h6 className="text-danger">
            Actualización de nodo hijo en proceso, favor no cerrar pantalla.
          </h6>
        )}
      </div>
      <div className="d-flex align-items-center">
        {loader && <Spinner className="mr-2" animation="border" size="sm" />}
        <FormCheck
          type="checkbox"
          onChange={(e) => handleAddUnidadNode(e, props.unidadId)}
          defaultChecked={props.state}
        />
      </div>
    </>
  );
};

const CrudAreas = (props) => {
  const schema = Yup.object().shape({
    codigo: Yup.string()
      .ensure()
      .test("codigo-format", "**Solo admite números y letras", (value) => {
        // Lógica de temporizador para la validación
        if (value === "" || !value) {
          return true; // Campo vacío, no validamos todavía
        }

        if (value.length < 1) {
          return true; // No validamos hasta que se escriban al menos 1 caracter
        }

        // Aquí puedes definir tu patrón personalizado
        const pattern = /^[a-zA-Z0-9\s]+$/;
        return pattern.test(value);
      })
      .required("**Campo requerido"),
    nombre: Yup.string().ensure().required("**Campo requerido"),
    sociedad_financiera: Yup.string().ensure().required("**Campo requerido"),
    Dirigido_por: Yup.string()
      .ensure()
      .test("codigo-format", "**Solo admite números", (value) => {
        // Lógica de temporizador para la validación
        if (value === "" || !value) {
          return true; // Campo vacío, no validamos todavía
        }

        if (value.length < 1) {
          return true; // No validamos hasta que se escriban al menos 1 caracter
        }

        // Aquí puedes definir tu patrón personalizado
        const pattern = /^[0-9]+$/;
        return pattern.test(value);
      })
      .required("**Campo requerido"),
  });

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [showModalUnidadNode, setShowModalUnidadNode] = useState(false);
  const [oUnidadNodes, setOUnidadNodes] = useState([]);
  const [nodeid, setNodeId] = useState({});
  const [filterBy, setFilterBy] = useState("codigo");
  const [sociedad, setSociedad] = useState("");

  const dispatch = useDispatch();

  const {
    areas: data,
    areasLength: dataLenght,
    areaError,
    areaFormErrors,
    loading,
    saveLoading,
  } = useSelector((store) => store.areas);
  const pages = Math.ceil(dataLenght / limit);

  const { loader, unidadNodes, formErrors, error } = useSelector(
    (store) => store.unidadNodes
  );
  const filterUnidadNodes = [
    { id: "codigo", desc: "Código" },
    { id: "nombre", desc: "Nombre" },
    { id: "dirigidoPor", desc: "Dirigido Por" },
  ];

  // Empresas
  const dataS = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);
  // const [isOrgSelect, setIsOrgSelect] = useState(false);

  const columns = [
    {
      Header: "Código",
      accessor: "codigo",
    },
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Dirigido por",
      accessor: "Dirigido_por",
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
          <Button
            size="sm"
            className="text-info"
            variant="link"
            type="button"
            onClick={() => handleShowModalUnidadNode(value.row.original)}
          >
            <i className="material-icons">ad_units</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const getAAreas = (
    offs = offset,
    lim = limit,
    filt = filter,
    socie = sociedad
  ) =>
    dispatch(
      getAreas(
        {
          offset: offs,
          limit: lim,
          filter: filt,
          sociedad_financiera: "",
        },
        parseInt(props.match.params.type)
      )
    );

  useEffect(() => {
    getAAreas();
  }, [props.match.params.type]);

  useEffect(() => {
    setOUnidadNodes(unidadNodes);
  }, [unidadNodes]);

  useEffect(() => {
    dispatch(getOrgs(parseInt(2)));
  }, []);
  const handleShowModalUnidadNode = (row) => {
    // if (row.id !== nodeid.nodeid) {
    // }
    setNodeId({ nodeid: row.id, codigo: row.codigo, nombre: row.nombre });
    dispatch(getUnidadNodes(row.id));
    setShowModalUnidadNode(true);
  };

  const addArea = () => {
    // if (sociedad !== "") {
    //   setIsOrgSelect(true);
    // } else {
    //   setIsOrgSelect(false);
    // }
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAAreas(oOffset, limit, e.target.filter.value);
  };

  const onSubmitAreas = (req) => {
    // e.preventDefault();
    // const form = e.currentTarget;
    // if (form.checkValidity() === false) {
    //   setValidated(true);
    //   return;
    // }

    // const req = {
    //   codigo: e.target.codigo.value,
    //   nombre: e.target.nombre.value,
    //   sociedad_financiera: [e.target.sociedad_financiera.value],
    //   Dirigido_por: e.target.dirigido.value,
    // };

    req.sociedad_financiera = [req.sociedad_financiera];

    if (!edit) {
      dispatch(saveAreas(req, parseInt(props.match.params.type), setShowModal));
      // e.target.reset();
      // setShowModal(false);
    } else {
      dispatch(
        editAreas(
          req,
          editItem.id,
          index,
          parseInt(props.match.params.type),
          setShowModal
        )
      );
      // setShowModal(false);
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAAreas(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteAreas(id, index, parseInt(props.match.params.type)));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  const handleFilter = (e) => {
    e.preventDefault();
    if (!e.target.uniNodeFilter.value.trim()) {
      return;
    }
    let filterUnitNodes = [];

    switch (filterBy) {
      case "codigo":
        filterUnitNodes = unidadNodes.filter(
          (item) => item.codigo === e.target.uniNodeFilter.value
        );
        break;
      case "nombre":
        filterUnitNodes = unidadNodes.filter((item) =>
          String(item.nombre).includes(e.target.uniNodeFilter.value)
        );
        break;
      case "dirigidoPor":
        filterUnitNodes = unidadNodes.filter((item) =>
          String(item.Dirigido_por).includes(e.target.uniNodeFilter.value)
        );
        break;
      default:
        filterUnitNodes = oUnidadNodes;
        break;
    }
    setOUnidadNodes(filterUnitNodes);
  };

  const handleSeeAllUnidadNodes = () => setOUnidadNodes(unidadNodes);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">Funcional Áreas</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => addArea()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {!!areaError && !loading && (
            <Alert variant="danger" className="m-2">
              {areaError}
            </Alert>
          )}
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={dataLenght}
                pages={pages}
                pagFunc={getAAreas}
              />
            </>
          ) : (
            <>
              {areaError === "" && (
                <Alert variant="info" className="my-4">
                  Aún no hay unidades, comienza agregando algunas
                </Alert>
              )}
            </>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmitAreas}
          initialValues={{
            codigo: edit ? editItem.codigo : "",
            nombre: edit ? editItem.nombre : "",
            sociedad_financiera: edit
              ? editItem.sociedad_financiera[0]
              : sociedad,
            Dirigido_por: edit ? editItem.Dirigido_por : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {edit
                    ? "Editar unidad organizativa"
                    : "Crear unidad organizativa"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!areaFormErrors && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {areaFormErrors}
                  </Alert>
                )}
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Código
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="codigo"
                      name="codigo"
                      isInvalid={touched.codigo && errors.codigo}
                      isValid={touched.codigo && !errors.codigo}
                      onBlur={handleBlur("codigo")}
                      onChange={handleChange}
                      value={values.codigo}
                      className="rounded-pill"
                      type="text"
                      placeholder="Código"
                      // pattern="[A-Za-z0-9]+"
                    ></Form.Control>
                    {touched.codigo && errors.codigo && (
                      // <div>
                      <small className="mx-2 text-danger">
                        {errors.codigo}
                      </small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite números y letras
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Nombre de unidad
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="nombre"
                      name="nombre"
                      isInvalid={touched.nombre && errors.nombre}
                      isValid={touched.nombre && !errors.nombre}
                      onBlur={handleBlur("nombre")}
                      onChange={handleChange}
                      value={values.nombre}
                      className="rounded-pill"
                      type="text"
                      placeholder="Nombre de unidad"
                    ></Form.Control>
                    {touched.nombre && errors.nombre && (
                      // <div>
                      <small className="mx-2 text-danger">
                        {errors.nombre}
                      </small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Sociedad Financiera
                  </Form.Label>
                  <Col sm={loadingOrgs ? "10" : "12"} md="8">
                    <Form.Control
                      id="sociedad_financiera"
                      name="sociedad_financiera"
                      isInvalid={
                        touched.sociedad_financiera &&
                        errors.sociedad_financiera
                      }
                      isValid={
                        touched.sociedad_financiera &&
                        !errors.sociedad_financiera
                      }
                      onBlur={handleBlur("sociedad_financiera")}
                      onChange={handleChange}
                      value={values.sociedad_financiera}
                      className="col rounded-pill"
                      as="select"
                      disabled={loadingOrgs}
                    >
                      <option className="text-muted" value="" selected disabled>
                        Seleccionar Sociedad
                      </option>
                      {dataS.length > 0 &&
                        dataS.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.nombre}
                          </option>
                        ))}
                    </Form.Control>
                    {touched.sociedad_financiera &&
                      errors.sociedad_financiera && (
                        // <div>
                        <small className="mx-2 text-danger">
                          {errors.sociedad_financiera}
                        </small>
                        // </div>
                      )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback> */}
                    {loadingOrgs ? (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    ) : null}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Dirigido por
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="Dirigido_por"
                      name="Dirigido_por"
                      isInvalid={touched.Dirigido_por && errors.Dirigido_por}
                      isValid={touched.Dirigido_por && !errors.Dirigido_por}
                      onBlur={handleBlur("Dirigido_por")}
                      onChange={handleChange}
                      value={values.Dirigido_por}
                      className="rounded-pill"
                      type="text"
                      placeholder="Dirigido por"
                    ></Form.Control>
                    {touched.Dirigido_por && errors.Dirigido_por && (
                      // <div>
                      <small className="mx-2 text-danger">
                        {errors.Dirigido_por}
                      </small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite números
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      <Modal
        size="lg"
        show={showModalUnidadNode}
        onHide={() => setShowModalUnidadNode(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {nodeid.nombre} <small className="text-sm">({nodeid.codigo})</small>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!!error && (
            <Alert variant="danger" className="mt-1 mb-2">
              {error}
            </Alert>
          )}
          {!!formErrors && (
            <Alert variant="danger" className="mt-1 mb-2">
              {formErrors}
            </Alert>
          )}
          <Card className="border-0">
            <Card.Body className="p-0">
              <Form className="px-3" onSubmit={handleFilter}>
                <Form.Group as={Row} className="aling-items-center">
                  <Form.Label column sm="auto" className="ml-2">
                    Filtrar: {filterBy}
                  </Form.Label>
                  <Col sm="7">
                    <Row className="d-flex align-items-center">
                      {loader ? (
                        <Col
                          xs="auto"
                          className="d-flex justify-content-center"
                        >
                          <Spinner
                            animation="border"
                            role="status"
                            className="d-flex justify-content-center"
                            size="sm"
                          />
                        </Col>
                      ) : null}
                      <Col md={loader ? 10 : 12}>
                        <Form.Control
                          id="uniNodeFilter"
                          name="uniNodeFilter"
                          placeholder="Filtrar"
                          className="rounded-pill"
                          type="search"
                          disabled={loader}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm="auto">
                    <ButtonGroup>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filterUnidadNodes.map((item) => (
                            <Dropdown.Item
                              onClick={() => setFilterBy(item.id)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                      <Button
                        variant="light"
                        size="sm"
                        className="rounded-circle ml-1"
                        onClick={() => handleSeeAllUnidadNodes()}
                      >
                        <i className="material-icons">list</i>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Form.Group>
                <hr />
              </Form>
              {loader ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : oUnidadNodes.length > 0 ? (
                <ListGroup variant="flush">
                  {oUnidadNodes.map((item) => (
                    <ListGroup.Item key={item.id}>
                      <div className="d-flex align-items-center justify-content-between">
                        <CustomCheckControl
                          item={item}
                          unidadId={item.id}
                          state={item.state}
                          nodeid={nodeid.nodeid}
                          unidadNodes={unidadNodes}
                        />
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              ) : (
                <Alert variant="info" className="my-4">
                  No hay registros que mostrar
                </Alert>
              )}
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModalUnidadNode(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CrudAreas;
